import dynamic from 'next/dynamic';
import { useWindowSize } from '@belong/common';

const ParticleLogoAIAnimation = dynamic(
  () => import('src/pages/particle_logo_ai_animation'),
  { ssr: false },
);

const BREAKPOINT = 1890;

export function HomeAnimations(): JSX.Element {
  const { width } = useWindowSize();
  const isLargeScreen = !isNaN(width) && width >= BREAKPOINT;

  return (
    <>
      {!isLargeScreen && (
        <div className="absolute inset-x-0 top-1/2 z-0 size-full -translate-y-1/2 overflow-hidden opacity-50">
          <ParticleLogoAIAnimation />
        </div>
      )}
      {isLargeScreen && (
        <div className="absolute inset-y-0 left-1/2 z-0 mx-auto size-full max-w-[1890px] -translate-x-1/2 overflow-hidden opacity-50">
          <ParticleLogoAIAnimation />
        </div>
      )}
    </>
  );
}
